/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { DischargePlansBySignatureViewModel } from './DischargePlansBySignatureViewModel'; 

export function getDischargePlansBySignatureOptions(dischargePlanSignatureId: string, onSuccess?: (result?: DischargePlansBySignatureViewModel) => void) {
	return queryOptions({
		queryKey: ['discharge-plans-by-signature', dischargePlanSignatureId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/discharges/queries/getdischargeplansbysignature/' + dischargePlanSignatureId;
			const resp = await axios.get<DischargePlansBySignatureViewModel | null>(url);
	        const result = resp.data ?? null;
	        onSuccess?.(result ?? undefined);
	        return result;
        },
        select: (x) => x ?? undefined,
        enabled: Boolean(dischargePlanSignatureId)
	});
}